export const idlFactory = ({ IDL }) => {
  const ApplicationId = IDL.Text;
  const InterviewSessionId = IDL.Text;
  const ActivityEventType = IDL.Variant({
    'InventoryUpdate' : IDL.Null,
    'System' : IDL.Null,
    'Access' : IDL.Null,
    'RelationshipChange' : IDL.Null,
    'ManualEdit' : IDL.Null,
    'Alert' : IDL.Null,
    'ConfigChange' : IDL.Null,
    'StatusChange' : IDL.Null,
    'Discovery' : IDL.Null,
    'Export' : IDL.Null,
  });
  const AddActivityLogRequest = IDL.Record({
    'user_principal' : IDL.Opt(IDL.Text),
    'action' : IDL.Text,
    'source' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'device_id' : IDL.Text,
    'details' : IDL.Text,
    'event_type' : ActivityEventType,
  });
  const ActivityLogId = IDL.Text;
  const DeviceActivityLog = IDL.Record({
    'id' : ActivityLogId,
    'user_principal' : IDL.Opt(IDL.Text),
    'action' : IDL.Text,
    'source' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'device_id' : IDL.Text,
    'timestamp' : IDL.Nat64,
    'details' : IDL.Text,
    'event_type' : ActivityEventType,
  });
  const DeviceId = IDL.Text;
  const BusinessServiceId = IDL.Text;
  const ComponentResponse = IDL.Record({
    'question' : IDL.Text,
    'component_id' : IDL.Text,
    'answer' : IDL.Text,
    'notes' : IDL.Opt(IDL.Text),
    'component_name' : IDL.Text,
    'confidence' : IDL.Opt(IDL.Float32),
  });
  const QuestionnaireResponseId = IDL.Text;
  const QuestionnaireResponse = IDL.Record({
    'components' : IDL.Vec(ComponentResponse),
    'section' : IDL.Text,
    'service_id' : BusinessServiceId,
    'response_id' : QuestionnaireResponseId,
    'questionnaire_version' : IDL.Text,
    'notes' : IDL.Opt(IDL.Text),
    'submitted_at' : IDL.Nat64,
    'submitted_by' : IDL.Text,
  });
  const RelationshipId = IDL.Text;
  const Relationship = IDL.Record({
    'updated_at' : IDL.Nat64,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'device_id' : DeviceId,
    'created_at' : IDL.Nat64,
    'relationship_type' : IDL.Text,
    'application_id' : ApplicationId,
    'relationship_id' : RelationshipId,
  });
  const BulkImportResult = IDL.Record({
    'total' : IDL.Nat32,
    'errors' : IDL.Vec(IDL.Text),
    'successful' : IDL.Nat32,
    'failed' : IDL.Nat32,
  });
  const CapabilityAssignmentRequest = IDL.Record({
    'platform_id' : IDL.Text,
    'is_primary' : IDL.Bool,
    'business_unit_id' : IDL.Text,
    'notes' : IDL.Opt(IDL.Text),
    'capability_id' : IDL.Text,
  });
  const BusinessCapabilityStorageRequest = IDL.Record({
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'icon' : IDL.Opt(IDL.Text),
    'name' : IDL.Text,
    'description' : IDL.Opt(IDL.Text),
    'display_order' : IDL.Nat32,
    'capability_id' : IDL.Text,
  });
  const BackOfficeSupportRequest = IDL.Record({
    'support_type' : IDL.Text,
    'notes' : IDL.Opt(IDL.Text),
    'front_office_unit_id' : IDL.Text,
    'back_office_unit_id' : IDL.Text,
  });
  const PlatformStorageRequest = IDL.Record({
    'platform_id' : IDL.Text,
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'name' : IDL.Text,
    'description' : IDL.Opt(IDL.Text),
    'icon_url' : IDL.Opt(IDL.Text),
    'vendor' : IDL.Opt(IDL.Text),
    'service_map_id' : IDL.Opt(IDL.Text),
  });
  const OfficeType = IDL.Variant({
    'FrontOffice' : IDL.Null,
    'BackOffice' : IDL.Null,
  });
  const BusinessUnitStorageRequest = IDL.Record({
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'name' : IDL.Text,
    'description' : IDL.Opt(IDL.Text),
    'office_type' : OfficeType,
    'business_unit_id' : IDL.Text,
  });
  const BulkBusinessCapabilityImport = IDL.Record({
    'assignments' : IDL.Vec(CapabilityAssignmentRequest),
    'capabilities' : IDL.Vec(BusinessCapabilityStorageRequest),
    'back_office_support' : IDL.Vec(BackOfficeSupportRequest),
    'platforms' : IDL.Vec(PlatformStorageRequest),
    'business_units' : IDL.Vec(BusinessUnitStorageRequest),
  });
  const BulkBusinessCapabilityImportResult = IDL.Record({
    'business_units_created' : IDL.Nat32,
    'errors' : IDL.Vec(IDL.Text),
    'assignments_created' : IDL.Nat32,
    'platforms_created' : IDL.Nat32,
    'message' : IDL.Text,
    'support_relationships_created' : IDL.Nat32,
    'success' : IDL.Bool,
    'capabilities_created' : IDL.Nat32,
  });
  const EABusinessServiceRequest = IDL.Record({
    'sla' : IDL.Text,
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'service_domain' : IDL.Text,
    'technical_service' : IDL.Text,
    'service_id' : IDL.Text,
    'service_owner' : IDL.Text,
    'service_offering' : IDL.Text,
    'channel' : IDL.Text,
    'business_service' : IDL.Text,
  });
  const EADataObjectRequest = IDL.Record({
    'domain' : IDL.Text,
    'owner' : IDL.Text,
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'name' : IDL.Text,
    'retention' : IDL.Text,
    'description' : IDL.Text,
    'key_attributes' : IDL.Text,
    'data_object_id' : IDL.Text,
    'source_system' : IDL.Text,
    'classification' : IDL.Text,
  });
  const EATechnicalServiceRequest = IDL.Record({
    'service_type' : IDL.Text,
    'application' : IDL.Text,
    'owner' : IDL.Text,
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'name' : IDL.Text,
    'description' : IDL.Text,
    'service_id' : IDL.Text,
    'api_interface' : IDL.Text,
    'availability_sla' : IDL.Text,
  });
  const EAHRRoleRequest = IDL.Record({
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'headcount' : IDL.Nat32,
    'role' : IDL.Text,
    'division' : IDL.Text,
    'role_id' : IDL.Text,
    'grade' : IDL.Text,
    'systems_used' : IDL.Text,
    'department' : IDL.Text,
    'location' : IDL.Text,
    'key_skills' : IDL.Text,
  });
  const EARelationshipRequest = IDL.Record({
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'source_id' : IDL.Text,
    'target_id' : IDL.Text,
    'relationship_type' : IDL.Text,
    'source_type' : IDL.Text,
    'relationship_id' : IDL.Opt(IDL.Text),
    'target_type' : IDL.Text,
  });
  const EAApplicationRequest = IDL.Record({
    'integrates_with' : IDL.Opt(IDL.Vec(IDL.Text)),
    'domain' : IDL.Text,
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'name' : IDL.Text,
    'description' : IDL.Text,
    'app_id' : IDL.Text,
    'vendor' : IDL.Text,
    'app_type' : IDL.Text,
    'users' : IDL.Nat32,
    'criticality' : IDL.Text,
    'integration_method' : IDL.Text,
  });
  const EAOrganizationRequest = IDL.Record({
    'key_responsibilities' : IDL.Text,
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'org_id' : IDL.Text,
    'headcount' : IDL.Nat32,
    'team' : IDL.Text,
    'division' : IDL.Text,
    'reports_to' : IDL.Text,
    'location_type' : IDL.Text,
    'department' : IDL.Text,
  });
  const BulkEAImport = IDL.Record({
    'business_services' : IDL.Vec(EABusinessServiceRequest),
    'data_objects' : IDL.Vec(EADataObjectRequest),
    'technical_services' : IDL.Vec(EATechnicalServiceRequest),
    'hr_roles' : IDL.Vec(EAHRRoleRequest),
    'relationships' : IDL.Vec(EARelationshipRequest),
    'applications' : IDL.Vec(EAApplicationRequest),
    'organizations' : IDL.Vec(EAOrganizationRequest),
  });
  const BulkEAImportResult = IDL.Record({
    'errors' : IDL.Vec(IDL.Text),
    'hr_roles_created' : IDL.Nat32,
    'business_services_created' : IDL.Nat32,
    'applications_created' : IDL.Nat32,
    'message' : IDL.Text,
    'success' : IDL.Bool,
    'data_objects_created' : IDL.Nat32,
    'technical_services_created' : IDL.Nat32,
    'relationships_created' : IDL.Nat32,
    'organizations_created' : IDL.Nat32,
  });
  // Sprint 45: New EA Entity Type Request Records
  const EACapabilityRequest = IDL.Record({
    'capability_id' : IDL.Text,
    'domain' : IDL.Text,
    'capability_l1' : IDL.Text,
    'capability_l2' : IDL.Text,
    'description' : IDL.Text,
    'owner' : IDL.Text,
    'key_systems' : IDL.Text,
    'maturity_level' : IDL.Text,
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
  });
  const EAProcessRequest = IDL.Record({
    'process_id' : IDL.Text,
    'process_domain' : IDL.Text,
    'process_name' : IDL.Text,
    'trigger' : IDL.Text,
    'steps' : IDL.Text,
    'owner' : IDL.Text,
    'sla' : IDL.Text,
    'volume_per_day' : IDL.Nat32,
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
  });
  const EAProcessConnectorRequest = IDL.Record({
    'connector_id' : IDL.Text,
    'process_id' : IDL.Text,
    'step_number' : IDL.Nat32,
    'step_name' : IDL.Text,
    'swim_lane' : IDL.Text,
    'location' : IDL.Text,
    'action' : IDL.Text,
    'system' : IDL.Text,
    'integration' : IDL.Text,
    'decision_point' : IDL.Text,
    'sla' : IDL.Text,
    'handoff_to' : IDL.Text,
    'linked_app_id' : IDL.Text,
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
  });
  const EAComplianceRequest = IDL.Record({
    'obligation_id' : IDL.Text,
    'regulation' : IDL.Text,
    'regulator' : IDL.Text,
    'category' : IDL.Text,
    'status' : IDL.Text,
    'executive' : IDL.Text,
    'in_scope_apps' : IDL.Opt(IDL.Vec(IDL.Text)),
    'linked_controls' : IDL.Opt(IDL.Vec(IDL.Text)),
    'linked_risk_categories' : IDL.Opt(IDL.Vec(IDL.Text)),
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
  });
  const EAIntegrationRequest = IDL.Record({
    'integration_id' : IDL.Text,
    'source_system' : IDL.Text,
    'target_system' : IDL.Text,
    'integration_type' : IDL.Text,
    'frequency' : IDL.Text,
    'data_exchanged' : IDL.Text,
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
  });
  const ProcessFlowStatus = IDL.Variant({
    'Active' : IDL.Null,
    'Draft' : IDL.Null,
    'Archived' : IDL.Null,
  });
  const ProcessFlowStorageRequest = IDL.Record({
    'status' : IDL.Opt(ProcessFlowStatus),
    'platform_id' : IDL.Opt(IDL.Text),
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'name' : IDL.Text,
    'description' : IDL.Text,
    'business_unit_id' : IDL.Text,
    'process_flow_id' : IDL.Text,
    'total_sla_hours' : IDL.Opt(IDL.Float64),
    'capability_id' : IDL.Text,
    'owner_role' : IDL.Text,
  });
  const ProcessStepType = IDL.Variant({
    'ManualReview' : IDL.Null,
    'Notification' : IDL.Null,
    'SystemAction' : IDL.Null,
    'HumanAction' : IDL.Null,
    'Decision' : IDL.Null,
    'Integration' : IDL.Null,
  });
  const ProcessStepStorageRequest = IDL.Record({
    'next_steps' : IDL.Opt(IDL.Vec(IDL.Text)),
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'name' : IDL.Text,
    'role' : IDL.Text,
    'step_number' : IDL.Nat32,
    'description' : IDL.Text,
    'step_id' : IDL.Text,
    'infrastructure' : IDL.Opt(IDL.Vec(IDL.Text)),
    'process_flow_id' : IDL.Text,
    'sla_hours' : IDL.Opt(IDL.Float64),
    'step_type' : ProcessStepType,
    'system' : IDL.Opt(IDL.Text),
    'decision_options' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
  });
  const BulkProcessFlowImport = IDL.Record({
    'flows' : IDL.Vec(ProcessFlowStorageRequest),
    'steps' : IDL.Vec(ProcessStepStorageRequest),
  });
  const BulkProcessFlowImportResult = IDL.Record({
    'steps_created' : IDL.Nat32,
    'errors' : IDL.Vec(IDL.Text),
    'flows_created' : IDL.Nat32,
  });
  const ControlRequest = IDL.Record({
    'control_id' : IDL.Text,
    'linked_risks' : IDL.Opt(IDL.Vec(IDL.Text)),
    'effectiveness' : IDL.Opt(IDL.Text),
    'last_tested' : IDL.Opt(IDL.Nat64),
    'control_type' : IDL.Text,
    'owner' : IDL.Opt(IDL.Text),
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'name' : IDL.Text,
    'description' : IDL.Opt(IDL.Text),
    'next_review' : IDL.Opt(IDL.Nat64),
    'evidence' : IDL.Opt(IDL.Text),
    'automation_level' : IDL.Opt(IDL.Text),
    'linked_applications' : IDL.Opt(IDL.Vec(IDL.Text)),
    'frequency' : IDL.Opt(IDL.Text),
  });
  const RiskRequest = IDL.Record({
    'sub_category' : IDL.Opt(IDL.Text),
    'status' : IDL.Opt(IDL.Text),
    'owner' : IDL.Opt(IDL.Text),
    'residual_risk' : IDL.Opt(IDL.Text),
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'name' : IDL.Text,
    'treatment' : IDL.Opt(IDL.Text),
    'description' : IDL.Opt(IDL.Text),
    'linked_controls' : IDL.Opt(IDL.Vec(IDL.Text)),
    'category' : IDL.Text,
    'linked_applications' : IDL.Opt(IDL.Vec(IDL.Text)),
    'severity' : IDL.Text,
    'inherent_risk' : IDL.Opt(IDL.Text),
    'likelihood' : IDL.Opt(IDL.Text),
    'risk_id' : IDL.Text,
  });
  const BulkRiskControlImport = IDL.Record({
    'controls' : IDL.Vec(ControlRequest),
    'risks' : IDL.Vec(RiskRequest),
  });
  const BulkRiskControlImportResult = IDL.Record({
    'controls_created' : IDL.Nat32,
    'errors' : IDL.Vec(IDL.Text),
    'risks_created' : IDL.Nat32,
    'message' : IDL.Text,
    'success' : IDL.Bool,
    'relationships_created' : IDL.Nat32,
  });
  const InterviewStatus = IDL.Variant({
    'Paused' : IDL.Null,
    'Scheduled' : IDL.Null,
    'Cancelled' : IDL.Null,
    'InProgress' : IDL.Null,
    'Completed' : IDL.Null,
  });
  const InterviewSession = IDL.Record({
    'status' : InterviewStatus,
    'conversation_history' : IDL.Vec(IDL.Text),
    'session_id' : InterviewSessionId,
    'sections_completed' : IDL.Vec(IDL.Text),
    'service_id' : BusinessServiceId,
    'notes' : IDL.Opt(IDL.Text),
    'scheduled_at' : IDL.Opt(IDL.Nat64),
    'participant_name' : IDL.Text,
    'participant_role' : IDL.Text,
    'sections_remaining' : IDL.Vec(IDL.Text),
    'completed_at' : IDL.Opt(IDL.Nat64),
    'started_at' : IDL.Opt(IDL.Nat64),
    'session_type' : IDL.Text,
  });
  const ServiceContact = IDL.Record({
    'name' : IDL.Text,
    'role' : IDL.Text,
    'is_primary' : IDL.Bool,
    'email' : IDL.Opt(IDL.Text),
    'phone' : IDL.Opt(IDL.Text),
  });
  const ServiceCriticality = IDL.Variant({
    'Low' : IDL.Null,
    'High' : IDL.Null,
    'Medium' : IDL.Null,
    'Critical' : IDL.Null,
    'Unknown' : IDL.Null,
  });
  const EntryPoint = IDL.Record({
    'url' : IDL.Opt(IDL.Text),
    'protocol' : IDL.Opt(IDL.Text),
    'port' : IDL.Opt(IDL.Nat32),
    'entry_type' : IDL.Text,
    'description' : IDL.Text,
  });
  const BusinessServiceStorageRequest = IDL.Record({
    'contacts' : IDL.Opt(IDL.Vec(ServiceContact)),
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'name' : IDL.Text,
    'description' : IDL.Text,
    'aliases' : IDL.Opt(IDL.Vec(IDL.Text)),
    'criticality' : IDL.Opt(ServiceCriticality),
    'entry_points' : IDL.Opt(IDL.Vec(EntryPoint)),
  });
  const ServiceStatus = IDL.Variant({
    'Review' : IDL.Null,
    'Approved' : IDL.Null,
    'Draft' : IDL.Null,
    'Archived' : IDL.Null,
    'InProgress' : IDL.Null,
    'Published' : IDL.Null,
  });
  const BusinessServiceStorageResponse = IDL.Record({
    'status' : ServiceStatus,
    'service_id' : BusinessServiceId,
    'message' : IDL.Text,
    'success' : IDL.Bool,
  });
  const BackOfficeSupportId = IDL.Text;
  const CapabilityId = IDL.Text;
  const BusinessUnitId = IDL.Text;
  const CapabilityAssignmentId = IDL.Text;
  const ControlId = IDL.Text;
  const EAApplicationId = IDL.Text;
  const EABusinessServiceId = IDL.Text;
  const EACapabilityId = IDL.Text;
  const EAComplianceId = IDL.Text;
  const EADataObjectId = IDL.Text;
  const EAHRRoleId = IDL.Text;
  const EAIntegrationId = IDL.Text;
  const EAOrganizationId = IDL.Text;
  const EAProcessConnectorId = IDL.Text;
  const EAProcessId = IDL.Text;
  const EARelationshipId = IDL.Text;
  const EATechnicalServiceId = IDL.Text;
  const PlatformId = IDL.Text;
  const ProcessFlowId = IDL.Text;
  const ProcessStepId = IDL.Text;
  const RiskId = IDL.Text;
  const SimilarityResult = IDL.Record({
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'device_id' : DeviceId,
    'similarity_score' : IDL.Float32,
  });
  const QueryResult = IDL.Record({
    'query_time_ms' : IDL.Nat64,
    'total_searched' : IDL.Nat32,
    'results' : IDL.Vec(SimilarityResult),
  });
  const ActivityLogStatistics = IDL.Record({
    'logs_by_type' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat64)),
    'logs_last_24h' : IDL.Nat64,
    'total_logs' : IDL.Nat64,
    'logs_by_device' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat64)),
    'logs_last_7d' : IDL.Nat64,
  });
  const ActivityLogListResponse = IDL.Record({
    'logs' : IDL.Vec(DeviceActivityLog),
    'total_count' : IDL.Nat64,
  });
  const BusinessService = IDL.Record({
    'status' : ServiceStatus,
    'updated_at' : IDL.Nat64,
    'contacts' : IDL.Vec(ServiceContact),
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'description' : IDL.Text,
    'created_at' : IDL.Nat64,
    'created_by' : IDL.Text,
    'service_id' : BusinessServiceId,
    'last_updated_by' : IDL.Text,
    'aliases' : IDL.Vec(IDL.Text),
    'criticality' : ServiceCriticality,
    'entry_points' : IDL.Vec(EntryPoint),
    'service_map_id' : IDL.Opt(IDL.Text),
  });
  const ConfigId = IDL.Text;
  const DeviceInventoryData = IDL.Record({
    'inventory_agent' : IDL.Opt(IDL.Text),
    'last_updated' : IDL.Nat64,
    'device_id' : IDL.Text,
    'hardware_id' : IDL.Opt(IDL.Text),
    'inventory_date' : IDL.Opt(IDL.Text),
    'inventory_fields' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
  });
  const FlexeraInventoryField = IDL.Record({
    'field_name' : IDL.Text,
    'is_required' : IDL.Bool,
    'field_type' : IDL.Text,
    'description' : IDL.Text,
    'default_value' : IDL.Opt(IDL.Text),
  });
  const ServiceMapId = IDL.Text;
  const TierDevice = IDL.Record({
    'config_files' : IDL.Vec(IDL.Text),
    'role' : IDL.Text,
    'hostname' : IDL.Text,
    'device_id' : IDL.Text,
    'ip_address' : IDL.Text,
  });
  const ServiceTier = IDL.Record({
    'tier_name' : IDL.Text,
    'tier_level' : IDL.Nat32,
    'devices' : IDL.Vec(TierDevice),
  });
  const ServiceMap = IDL.Record({
    'tiers' : IDL.Vec(ServiceTier),
    'updated_at' : IDL.Nat64,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'created_at' : IDL.Nat64,
    'service_id' : IDL.Text,
  });
  const BUCapabilityPlatform = IDL.Record({
    'updated_at' : IDL.Nat64,
    'platform_id' : PlatformId,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'is_primary' : IDL.Bool,
    'created_at' : IDL.Nat64,
    'business_unit_id' : BusinessUnitId,
    'notes' : IDL.Opt(IDL.Text),
    'assignment_id' : CapabilityAssignmentId,
    'capability_id' : CapabilityId,
  });
  const BusinessUnit = IDL.Record({
    'updated_at' : IDL.Nat64,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'description' : IDL.Opt(IDL.Text),
    'created_at' : IDL.Nat64,
    'office_type' : OfficeType,
    'business_unit_id' : BusinessUnitId,
  });
  const BusinessCapability = IDL.Record({
    'updated_at' : IDL.Nat64,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'icon' : IDL.Opt(IDL.Text),
    'name' : IDL.Text,
    'description' : IDL.Opt(IDL.Text),
    'created_at' : IDL.Nat64,
    'display_order' : IDL.Nat32,
    'capability_id' : CapabilityId,
  });
  const PlatformSummary = IDL.Record({
    'platform_id' : IDL.Text,
    'name' : IDL.Text,
    'is_primary' : IDL.Bool,
    'icon_url' : IDL.Opt(IDL.Text),
    'service_map_id' : IDL.Opt(IDL.Text),
  });
  const BusinessCapabilityMatrixEntry = IDL.Record({
    'office_type' : OfficeType,
    'platforms' : IDL.Vec(PlatformSummary),
    'business_unit_id' : IDL.Text,
    'capability_name' : IDL.Text,
    'business_unit_name' : IDL.Text,
    'capability_id' : IDL.Text,
  });
  const BusinessCapabilityStatistics = IDL.Record({
    'total_capabilities' : IDL.Nat32,
    'front_office_units' : IDL.Nat32,
    'total_business_units' : IDL.Nat32,
    'back_office_units' : IDL.Nat32,
    'total_platforms' : IDL.Nat32,
    'platform_usage' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32)),
    'total_assignments' : IDL.Nat32,
  });
  const Embedding = IDL.Vec(IDL.Float32);
  const ConfigEmbedding = IDL.Record({
    'ip' : IDL.Text,
    'updated_at' : IDL.Nat64,
    'content' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'path' : IDL.Text,
    'created_at' : IDL.Nat64,
    'embedding' : Embedding,
    'config_id' : ConfigId,
    'config_type' : IDL.Text,
    'device_sys_id' : IDL.Text,
  });
  const Control = IDL.Record({
    'control_id' : ControlId,
    'updated_at' : IDL.Nat64,
    'linked_risks' : IDL.Vec(RiskId),
    'effectiveness' : IDL.Text,
    'last_tested' : IDL.Opt(IDL.Nat64),
    'control_type' : IDL.Text,
    'owner' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'description' : IDL.Text,
    'created_at' : IDL.Nat64,
    'next_review' : IDL.Opt(IDL.Nat64),
    'evidence' : IDL.Opt(IDL.Text),
    'automation_level' : IDL.Opt(IDL.Text),
    'linked_applications' : IDL.Vec(IDL.Text),
    'frequency' : IDL.Opt(IDL.Text),
  });
  const DeviceEmbedding = IDL.Record({
    'ip' : IDL.Text,
    'status' : IDL.Text,
    'updated_at' : IDL.Nat64,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'hostname' : IDL.Opt(IDL.Text),
    'device_type' : IDL.Text,
    'device_id' : DeviceId,
    'created_at' : IDL.Nat64,
    'embedding' : Embedding,
    'sys_id' : IDL.Text,
  });
  const DeviceStatistics = IDL.Record({
    'unknown_devices' : IDL.Nat32,
    'device_types' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32)),
    'total_devices' : IDL.Nat32,
    'offline_devices' : IDL.Nat32,
    'maintenance_devices' : IDL.Nat32,
    'online_devices' : IDL.Nat32,
  });
  const DocumentType = IDL.Variant({
    'SLA' : IDL.Null,
    'Contract' : IDL.Null,
    'Architecture' : IDL.Null,
    'RunBook' : IDL.Null,
    'Other' : IDL.Null,
    'Questionnaire' : IDL.Null,
  });
  const ServiceDocumentId = IDL.Text;
  const ServiceDocument = IDL.Record({
    'content' : IDL.Opt(IDL.Vec(IDL.Nat8)),
    'document_type' : DocumentType,
    'document_id' : ServiceDocumentId,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'content_hash' : IDL.Text,
    'content_type' : IDL.Text,
    'extracted_text' : IDL.Opt(IDL.Text),
    'file_size' : IDL.Nat64,
    'filename' : IDL.Text,
    'service_id' : BusinessServiceId,
    'uploaded_at' : IDL.Nat64,
    'uploaded_by' : IDL.Text,
  });
  const EAApplication = IDL.Record({
    'integrates_with' : IDL.Vec(IDL.Text),
    'updated_at' : IDL.Nat64,
    'domain' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'description' : IDL.Text,
    'created_at' : IDL.Nat64,
    'app_id' : EAApplicationId,
    'vendor' : IDL.Text,
    'app_type' : IDL.Text,
    'users' : IDL.Nat32,
    'criticality' : IDL.Text,
    'integration_method' : IDL.Text,
  });
  const EABusinessService = IDL.Record({
    'sla' : IDL.Text,
    'updated_at' : IDL.Nat64,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'service_domain' : IDL.Text,
    'created_at' : IDL.Nat64,
    'technical_service' : IDL.Text,
    'service_id' : EABusinessServiceId,
    'service_owner' : IDL.Text,
    'service_offering' : IDL.Text,
    'channel' : IDL.Text,
    'business_service' : IDL.Text,
  });
  const EADataObject = IDL.Record({
    'updated_at' : IDL.Nat64,
    'domain' : IDL.Text,
    'owner' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'retention' : IDL.Text,
    'description' : IDL.Text,
    'key_attributes' : IDL.Text,
    'created_at' : IDL.Nat64,
    'data_object_id' : EADataObjectId,
    'source_system' : IDL.Text,
    'classification' : IDL.Text,
  });
  const EAHRRole = IDL.Record({
    'updated_at' : IDL.Nat64,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'headcount' : IDL.Nat32,
    'role' : IDL.Text,
    'division' : IDL.Text,
    'role_id' : EAHRRoleId,
    'created_at' : IDL.Nat64,
    'grade' : IDL.Text,
    'systems_used' : IDL.Text,
    'department' : IDL.Text,
    'location' : IDL.Text,
    'key_skills' : IDL.Text,
  });
  const EAOrganization = IDL.Record({
    'updated_at' : IDL.Nat64,
    'key_responsibilities' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'org_id' : EAOrganizationId,
    'headcount' : IDL.Nat32,
    'team' : IDL.Text,
    'division' : IDL.Text,
    'created_at' : IDL.Nat64,
    'reports_to' : IDL.Text,
    'location_type' : IDL.Text,
    'department' : IDL.Text,
  });
  const EARelationship = IDL.Record({
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'source_id' : IDL.Text,
    'target_id' : IDL.Text,
    'created_at' : IDL.Nat64,
    'relationship_type' : IDL.Text,
    'source_type' : IDL.Text,
    'relationship_id' : EARelationshipId,
    'target_type' : IDL.Text,
  });
  const EAStatistics = IDL.Record({
    'total_data_objects' : IDL.Nat32,
    'applications_by_criticality' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32)),
    'total_hr_roles' : IDL.Nat32,
    'total_organizations' : IDL.Nat32,
    'total_business_services' : IDL.Nat32,
    'total_headcount' : IDL.Nat32,
    'total_applications' : IDL.Nat32,
    'organizations_by_division' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32)),
    'applications_by_domain' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32)),
    'total_technical_services' : IDL.Nat32,
    'total_relationships' : IDL.Nat32,
    'total_capabilities' : IDL.Nat32,
    'total_processes' : IDL.Nat32,
    'total_process_connectors' : IDL.Nat32,
    'total_compliance' : IDL.Nat32,
    'total_integrations' : IDL.Nat32,
    'capabilities_by_domain' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32)),
  });
  const EATechnicalService = IDL.Record({
    'updated_at' : IDL.Nat64,
    'service_type' : IDL.Text,
    'application' : IDL.Text,
    'owner' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'description' : IDL.Text,
    'created_at' : IDL.Nat64,
    'service_id' : EATechnicalServiceId,
    'api_interface' : IDL.Text,
    'availability_sla' : IDL.Text,
  });
  // Sprint 45: New EA Entity Type Response Records
  const EACapability = IDL.Record({
    'capability_id' : EACapabilityId,
    'domain' : IDL.Text,
    'capability_l1' : IDL.Text,
    'capability_l2' : IDL.Text,
    'description' : IDL.Text,
    'owner' : IDL.Text,
    'key_systems' : IDL.Text,
    'maturity_level' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'created_at' : IDL.Nat64,
    'updated_at' : IDL.Nat64,
  });
  const EAProcess = IDL.Record({
    'process_id' : EAProcessId,
    'process_domain' : IDL.Text,
    'process_name' : IDL.Text,
    'trigger' : IDL.Text,
    'steps' : IDL.Text,
    'owner' : IDL.Text,
    'sla' : IDL.Text,
    'volume_per_day' : IDL.Nat32,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'created_at' : IDL.Nat64,
    'updated_at' : IDL.Nat64,
  });
  const EAProcessConnector = IDL.Record({
    'connector_id' : EAProcessConnectorId,
    'process_id' : IDL.Text,
    'step_number' : IDL.Nat32,
    'step_name' : IDL.Text,
    'swim_lane' : IDL.Text,
    'location' : IDL.Text,
    'action' : IDL.Text,
    'system' : IDL.Text,
    'integration' : IDL.Text,
    'decision_point' : IDL.Text,
    'sla' : IDL.Text,
    'handoff_to' : IDL.Text,
    'linked_app_id' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'created_at' : IDL.Nat64,
    'updated_at' : IDL.Nat64,
  });
  const EACompliance = IDL.Record({
    'obligation_id' : EAComplianceId,
    'regulation' : IDL.Text,
    'regulator' : IDL.Text,
    'category' : IDL.Text,
    'status' : IDL.Text,
    'executive' : IDL.Text,
    'in_scope_apps' : IDL.Vec(IDL.Text),
    'linked_controls' : IDL.Vec(IDL.Text),
    'linked_risk_categories' : IDL.Vec(IDL.Text),
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'created_at' : IDL.Nat64,
    'updated_at' : IDL.Nat64,
  });
  const EAIntegration = IDL.Record({
    'integration_id' : EAIntegrationId,
    'source_system' : IDL.Text,
    'target_system' : IDL.Text,
    'integration_type' : IDL.Text,
    'frequency' : IDL.Text,
    'data_exchanged' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'created_at' : IDL.Nat64,
    'updated_at' : IDL.Nat64,
  });
  const Platform = IDL.Record({
    'updated_at' : IDL.Nat64,
    'platform_id' : PlatformId,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'description' : IDL.Opt(IDL.Text),
    'created_at' : IDL.Nat64,
    'icon_url' : IDL.Opt(IDL.Text),
    'vendor' : IDL.Opt(IDL.Text),
    'service_map_id' : IDL.Opt(IDL.Text),
  });
  const ProcessFlow = IDL.Record({
    'status' : ProcessFlowStatus,
    'updated_at' : IDL.Nat64,
    'platform_id' : IDL.Opt(IDL.Text),
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'description' : IDL.Text,
    'created_at' : IDL.Nat64,
    'business_unit_id' : IDL.Text,
    'process_flow_id' : ProcessFlowId,
    'total_sla_hours' : IDL.Opt(IDL.Float64),
    'capability_id' : IDL.Text,
    'owner_role' : IDL.Text,
  });
  const ProcessFlowStatistics = IDL.Record({
    'flows_by_business_unit' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32)),
    'total_steps' : IDL.Nat32,
    'total_flows' : IDL.Nat32,
    'avg_steps_per_flow' : IDL.Float64,
    'flows_by_status' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32)),
  });
  const ProcessStep = IDL.Record({
    'next_steps' : IDL.Vec(IDL.Text),
    'updated_at' : IDL.Nat64,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'role' : IDL.Text,
    'step_number' : IDL.Nat32,
    'description' : IDL.Text,
    'created_at' : IDL.Nat64,
    'step_id' : ProcessStepId,
    'infrastructure' : IDL.Vec(IDL.Text),
    'process_flow_id' : ProcessFlowId,
    'sla_hours' : IDL.Opt(IDL.Float64),
    'step_type' : ProcessStepType,
    'system' : IDL.Opt(IDL.Text),
    'decision_options' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
  });
  const Risk = IDL.Record({
    'sub_category' : IDL.Opt(IDL.Text),
    'status' : IDL.Text,
    'updated_at' : IDL.Nat64,
    'owner' : IDL.Text,
    'residual_risk' : IDL.Opt(IDL.Text),
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'treatment' : IDL.Opt(IDL.Text),
    'description' : IDL.Text,
    'created_at' : IDL.Nat64,
    'linked_controls' : IDL.Vec(ControlId),
    'category' : IDL.Text,
    'linked_applications' : IDL.Vec(IDL.Text),
    'severity' : IDL.Text,
    'inherent_risk' : IDL.Opt(IDL.Text),
    'likelihood' : IDL.Text,
    'risk_id' : RiskId,
  });
  const RiskStatistics = IDL.Record({
    'risks_by_category' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32)),
    'risks_by_severity' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32)),
    'existential_risks' : IDL.Nat32,
    'controls_by_type' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32)),
    'total_risks' : IDL.Nat32,
    'risks_by_status' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32)),
    'total_controls' : IDL.Nat32,
    'controls_by_effectiveness' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32)),
  });
  const TimezoneConfig = IDL.Record({
    'description' : IDL.Text,
    'label' : IDL.Text,
    'utc_offset_hours' : IDL.Int32,
  });
  const ConfigSimilarityResult = IDL.Record({
    'ip' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'path' : IDL.Text,
    'config_id' : ConfigId,
    'similarity_score' : IDL.Float32,
    'config_type' : IDL.Text,
  });
  const ConfigQueryResult = IDL.Record({
    'query_time_ms' : IDL.Nat64,
    'total_searched' : IDL.Nat32,
    'results' : IDL.Vec(ConfigSimilarityResult),
  });
  const ConfigFileData = IDL.Record({
    'content' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'path' : IDL.Text,
    'config_type' : IDL.Text,
  });
  const DiscoveryMetadata = IDL.Record({
    'session_id' : IDL.Opt(IDL.Text),
    'source' : IDL.Text,
    'discovery_timestamp' : IDL.Nat64,
    'discovery_method' : IDL.Text,
  });
  const DeviceData = IDL.Record({
    'ip' : IDL.Text,
    'os' : IDL.Opt(IDL.Text),
    'status' : IDL.Text,
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'hostname' : IDL.Opt(IDL.Text),
    'device_type' : IDL.Text,
    'device_id' : IDL.Text,
  });
  const ApplicationData = IDL.Record({
    'metadata' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'name' : IDL.Text,
    'relationship_type' : IDL.Text,
    'application_id' : IDL.Text,
    'app_type' : IDL.Text,
  });
  const InventoryData = IDL.Record({
    'agent' : IDL.Opt(IDL.Text),
    'fields' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'hardware_id' : IDL.Opt(IDL.Text),
    'inventory_date' : IDL.Opt(IDL.Text),
  });
  const StorageRequest = IDL.Record({
    'config_files' : IDL.Vec(ConfigFileData),
    'discovery_metadata' : DiscoveryMetadata,
    'device_data' : DeviceData,
    'applications' : IDL.Vec(ApplicationData),
    'inventory_data' : IDL.Opt(InventoryData),
  });
  const StorageError = IDL.Variant({
    'DeviceStorageError' : IDL.Record({
      'device_id' : IDL.Text,
      'reason' : IDL.Text,
    }),
    'ConfigStorageError' : IDL.Record({
      'path' : IDL.Text,
      'reason' : IDL.Text,
    }),
    'RelationshipStorageError' : IDL.Record({
      'device_id' : IDL.Text,
      'app_id' : IDL.Text,
      'reason' : IDL.Text,
    }),
    'InventoryStorageError' : IDL.Record({ 'reason' : IDL.Text }),
    'ValidationError' : IDL.Record({
      'field' : IDL.Text,
      'message' : IDL.Text,
    }),
    'DuplicateDeviceError' : IDL.Record({ 'device_id' : IDL.Text }),
    'ApplicationStorageError' : IDL.Record({
      'app_id' : IDL.Text,
      'reason' : IDL.Text,
    }),
    'InternalError' : IDL.Record({ 'message' : IDL.Text }),
  });
  const StorageSummary = IDL.Record({
    'configs_stored' : IDL.Nat32,
    'storage_time_ms' : IDL.Nat64,
    'device_id' : IDL.Text,
    'inventory_stored' : IDL.Bool,
    'sys_id' : IDL.Text,
    'applications_stored' : IDL.Nat32,
    'relationships_created' : IDL.Nat32,
  });
  const StorageResponse = IDL.Record({
    'error' : IDL.Opt(StorageError),
    'summary' : StorageSummary,
    'warnings' : IDL.Vec(IDL.Text),
    'success' : IDL.Bool,
  });
  const ServiceMapStorageRequest = IDL.Record({
    'tiers' : IDL.Vec(ServiceTier),
    'metadata' : IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    'name' : IDL.Text,
  });
  const ServiceMapStorageResponse = IDL.Record({
    'service_id' : IDL.Text,
    'applications_created' : IDL.Nat32,
    'message' : IDL.Text,
    'success' : IDL.Bool,
    'relationships_created' : IDL.Nat32,
  });
  return IDL.Service({
    'add_application' : IDL.Func(
        [ApplicationId, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))],
        [IDL.Variant({ 'Ok' : IDL.Null, 'Err' : IDL.Text })],
        [],
      ),
    'add_conversation_message' : IDL.Func(
        [InterviewSessionId, IDL.Text],
        [IDL.Variant({ 'Ok' : IDL.Null, 'Err' : IDL.Text })],
        [],
      ),
    'add_device_activity_log' : IDL.Func(
        [AddActivityLogRequest],
        [IDL.Variant({ 'Ok' : DeviceActivityLog, 'Err' : IDL.Text })],
        [],
      ),
    'add_device_inventory_data' : IDL.Func(
        [
          IDL.Text,
          IDL.Opt(IDL.Text),
          IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
          IDL.Opt(IDL.Text),
        ],
        [IDL.Variant({ 'Ok' : IDL.Null, 'Err' : IDL.Text })],
        [],
      ),
    'add_embedding' : IDL.Func(
        [DeviceId, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'add_questionnaire_response' : IDL.Func(
        [
          BusinessServiceId,
          IDL.Text,
          IDL.Vec(ComponentResponse),
          IDL.Text,
          IDL.Opt(IDL.Text),
        ],
        [IDL.Variant({ 'Ok' : QuestionnaireResponse, 'Err' : IDL.Text })],
        [],
      ),
    'add_relationship' : IDL.Func(
        [
          RelationshipId,
          DeviceId,
          ApplicationId,
          IDL.Text,
          IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
        ],
        [IDL.Variant({ 'Ok' : IDL.Null, 'Err' : IDL.Text })],
        [],
      ),
    'bulk_add_relationships' : IDL.Func(
        [IDL.Vec(Relationship)],
        [BulkImportResult],
        [],
      ),
    'bulk_import_applications' : IDL.Func(
        [
          IDL.Vec(
            IDL.Tuple(ApplicationId, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)))
          ),
        ],
        [BulkImportResult],
        [],
      ),
    'bulk_import_business_capabilities' : IDL.Func(
        [BulkBusinessCapabilityImport],
        [BulkBusinessCapabilityImportResult],
        [],
      ),
    'bulk_import_devices' : IDL.Func(
        [IDL.Vec(IDL.Tuple(DeviceId, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))))],
        [BulkImportResult],
        [],
      ),
    'bulk_import_ea' : IDL.Func([BulkEAImport], [BulkEAImportResult], []),
    'bulk_import_process_flows' : IDL.Func(
        [BulkProcessFlowImport],
        [BulkProcessFlowImportResult],
        [],
      ),
    'bulk_import_risks_controls' : IDL.Func(
        [BulkRiskControlImport],
        [BulkRiskControlImportResult],
        [],
      ),
    'clear_all_activity_logs' : IDL.Func(
        [],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'clear_all_business_capability_data' : IDL.Func(
        [],
        [IDL.Nat32, IDL.Nat32, IDL.Nat32, IDL.Nat32, IDL.Nat32],
        [],
      ),
    'clear_all_business_service_data' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32))],
        [],
      ),
    'clear_all_data' : IDL.Func(
        [],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'clear_all_process_flow_data' : IDL.Func([], [IDL.Nat32, IDL.Nat32], []),
    'clear_ea_data' : IDL.Func([], [IDL.Text], []),
    'clear_ea_diagrams' : IDL.Func([], [IDL.Nat32], []),
    'clear_new_ea_types_data' : IDL.Func([], [IDL.Text], []),
    'clear_risk_control_data' : IDL.Func([], [IDL.Text], []),
    'complete_interview_section' : IDL.Func(
        [InterviewSessionId, IDL.Text],
        [IDL.Variant({ 'Ok' : InterviewSession, 'Err' : IDL.Text })],
        [],
      ),
    'create_business_service' : IDL.Func(
        [BusinessServiceStorageRequest, IDL.Text],
        [BusinessServiceStorageResponse],
        [],
      ),
    'create_interview_session' : IDL.Func(
        [
          BusinessServiceId,
          IDL.Text,
          IDL.Text,
          IDL.Text,
          IDL.Vec(IDL.Text),
          IDL.Opt(IDL.Nat64),
        ],
        [IDL.Variant({ 'Ok' : InterviewSession, 'Err' : IDL.Text })],
        [],
      ),
    'delete_back_office_support' : IDL.Func(
        [BackOfficeSupportId],
        [IDL.Bool],
        [],
      ),
    'delete_business_capability' : IDL.Func([CapabilityId], [IDL.Bool], []),
    'delete_business_service' : IDL.Func(
        [BusinessServiceId],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'delete_business_unit' : IDL.Func([BusinessUnitId], [IDL.Bool], []),
    'delete_capability_assignment' : IDL.Func(
        [CapabilityAssignmentId],
        [IDL.Bool],
        [],
      ),
    'delete_control' : IDL.Func([ControlId], [IDL.Bool], []),
    'delete_ea_application' : IDL.Func([EAApplicationId], [IDL.Bool], []),
    'delete_ea_business_service' : IDL.Func(
        [EABusinessServiceId],
        [IDL.Bool],
        [],
      ),
    'delete_ea_capability' : IDL.Func([EACapabilityId], [IDL.Bool], []),
    'delete_ea_compliance' : IDL.Func([EAComplianceId], [IDL.Bool], []),
    'delete_ea_data_object' : IDL.Func([EADataObjectId], [IDL.Bool], []),
    'delete_ea_hr_role' : IDL.Func([EAHRRoleId], [IDL.Bool], []),
    'delete_ea_integration' : IDL.Func([EAIntegrationId], [IDL.Bool], []),
    'delete_ea_organization' : IDL.Func([EAOrganizationId], [IDL.Bool], []),
    'delete_ea_process' : IDL.Func([EAProcessId], [IDL.Bool], []),
    'delete_ea_process_connector' : IDL.Func([EAProcessConnectorId], [IDL.Bool], []),
    'delete_ea_relationship' : IDL.Func([EARelationshipId], [IDL.Bool], []),
    'delete_ea_technical_service' : IDL.Func(
        [EATechnicalServiceId],
        [IDL.Bool],
        [],
      ),
    'delete_platform' : IDL.Func([PlatformId], [IDL.Bool], []),
    'delete_process_flow' : IDL.Func(
        [ProcessFlowId],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'delete_process_step' : IDL.Func(
        [ProcessStepId],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'delete_risk' : IDL.Func([RiskId], [IDL.Bool], []),
    'delete_service_map' : IDL.Func(
        [IDL.Text],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'find_device_in_service_maps' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text, IDL.Text, IDL.Text, IDL.Text))],
        ['query'],
      ),
    'find_similar_devices' : IDL.Func(
        [DeviceId, IDL.Nat32],
        [IDL.Variant({ 'Ok' : QueryResult, 'Err' : IDL.Text })],
        ['query'],
      ),
    'get_activity_log' : IDL.Func(
        [IDL.Text],
        [IDL.Opt(DeviceActivityLog)],
        ['query'],
      ),
    'get_activity_log_statistics' : IDL.Func(
        [],
        [ActivityLogStatistics],
        ['query'],
      ),
    'get_all_activity_logs' : IDL.Func(
        [IDL.Nat64, IDL.Nat64],
        [ActivityLogListResponse],
        ['query'],
      ),
    'get_all_applications' : IDL.Func(
        [],
        [
          IDL.Vec(
            IDL.Tuple(ApplicationId, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)))
          ),
        ],
        ['query'],
      ),
    'get_all_business_services' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(BusinessServiceId, BusinessService))],
        ['query'],
      ),
    'get_all_configs' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(ConfigId, IDL.Text, IDL.Text, IDL.Text))],
        ['query'],
      ),
    'get_all_device_inventory' : IDL.Func(
        [],
        [IDL.Vec(DeviceInventoryData)],
        ['query'],
      ),
    'get_all_devices' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(DeviceId, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))))],
        ['query'],
      ),
    'get_all_inventory_fields' : IDL.Func(
        [],
        [IDL.Vec(FlexeraInventoryField)],
        ['query'],
      ),
    'get_all_relationships' : IDL.Func([], [IDL.Vec(Relationship)], ['query']),
    'get_all_service_maps' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(ServiceMapId, ServiceMap))],
        ['query'],
      ),
    'get_application_devices' : IDL.Func(
        [ApplicationId],
        [
          IDL.Vec(
            IDL.Tuple(
              DeviceId,
              IDL.Text,
              IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
            )
          ),
        ],
        ['query'],
      ),
    'get_applications_by_type' : IDL.Func(
        [IDL.Text],
        [
          IDL.Vec(
            IDL.Tuple(ApplicationId, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)))
          ),
        ],
        ['query'],
      ),
    'get_assignments_for_business_unit' : IDL.Func(
        [BusinessUnitId],
        [IDL.Vec(BUCapabilityPlatform)],
        ['query'],
      ),
    'get_back_office_supporters' : IDL.Func(
        [BusinessUnitId],
        [IDL.Vec(BusinessUnit)],
        ['query'],
      ),
    'get_business_capability' : IDL.Func(
        [CapabilityId],
        [IDL.Opt(BusinessCapability)],
        ['query'],
      ),
    'get_business_service' : IDL.Func(
        [BusinessServiceId],
        [IDL.Opt(BusinessService)],
        ['query'],
      ),
    'get_business_service_count' : IDL.Func([], [IDL.Nat32], ['query']),
    'get_business_service_statistics' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32))],
        ['query'],
      ),
    'get_business_services_by_status' : IDL.Func(
        [ServiceStatus],
        [IDL.Vec(IDL.Tuple(BusinessServiceId, BusinessService))],
        ['query'],
      ),
    'get_business_unit' : IDL.Func(
        [BusinessUnitId],
        [IDL.Opt(BusinessUnit)],
        ['query'],
      ),
    'get_capability_matrix' : IDL.Func(
        [],
        [IDL.Vec(BusinessCapabilityMatrixEntry)],
        ['query'],
      ),
    'get_capability_platforms' : IDL.Func(
        [BusinessUnitId, CapabilityId],
        [IDL.Vec(PlatformSummary)],
        ['query'],
      ),
    'get_capability_statistics' : IDL.Func(
        [],
        [BusinessCapabilityStatistics],
        ['query'],
      ),
    'get_config_by_id' : IDL.Func(
        [ConfigId],
        [IDL.Opt(ConfigEmbedding)],
        ['query'],
      ),
    'get_configs_by_ip' : IDL.Func(
        [IDL.Text],
        [
          IDL.Vec(
            IDL.Tuple(
              ConfigId,
              IDL.Text,
              IDL.Text,
              IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
            )
          ),
        ],
        ['query'],
      ),
    'get_configs_by_service_name' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(IDL.Tuple(ConfigId, IDL.Text, IDL.Text, IDL.Text))],
        ['query'],
      ),
    'get_configs_count' : IDL.Func([], [IDL.Nat64], ['query']),
    'get_control' : IDL.Func([ControlId], [IDL.Opt(Control)], ['query']),
    'get_controls_for_risk' : IDL.Func([RiskId], [IDL.Vec(Control)], ['query']),
    'get_database_stats' : IDL.Func(
        [],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Nat32))],
        ['query'],
      ),
    'get_device_activity_logs' : IDL.Func(
        [IDL.Text, IDL.Nat64, IDL.Nat64],
        [ActivityLogListResponse],
        ['query'],
      ),
    'get_device_applications' : IDL.Func(
        [DeviceId],
        [
          IDL.Vec(
            IDL.Tuple(
              ApplicationId,
              IDL.Text,
              IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
            )
          ),
        ],
        ['query'],
      ),
    'get_device_by_device_id' : IDL.Func(
        [IDL.Text],
        [IDL.Opt(DeviceEmbedding)],
        ['query'],
      ),
    'get_device_by_hostname' : IDL.Func(
        [IDL.Text],
        [IDL.Opt(DeviceEmbedding)],
        ['query'],
      ),
    'get_device_by_ip' : IDL.Func(
        [IDL.Text],
        [IDL.Opt(DeviceEmbedding)],
        ['query'],
      ),
    'get_device_by_sys_id' : IDL.Func(
        [IDL.Text],
        [IDL.Opt(DeviceEmbedding)],
        ['query'],
      ),
    'get_device_inventory_data' : IDL.Func(
        [IDL.Text],
        [IDL.Opt(DeviceInventoryData)],
        ['query'],
      ),
    'get_device_statistics' : IDL.Func([], [DeviceStatistics], ['query']),
    'get_devices_by_service' : IDL.Func(
        [IDL.Text],
        [
          IDL.Vec(
            IDL.Tuple(
              IDL.Text,
              IDL.Text,
              IDL.Text,
              IDL.Text,
              IDL.Text,
              IDL.Nat32,
            )
          ),
        ],
        ['query'],
      ),
    'get_devices_by_type' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(IDL.Tuple(DeviceId, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))))],
        ['query'],
      ),
    'get_documents_for_service' : IDL.Func(
        [BusinessServiceId],
        [IDL.Vec(ServiceDocument)],
        ['query'],
      ),
    'get_ea_application' : IDL.Func(
        [EAApplicationId],
        [IDL.Opt(EAApplication)],
        ['query'],
      ),
    'get_ea_business_service' : IDL.Func(
        [EABusinessServiceId],
        [IDL.Opt(EABusinessService)],
        ['query'],
      ),
    'get_ea_capability' : IDL.Func(
        [EACapabilityId],
        [IDL.Opt(EACapability)],
        ['query'],
      ),
    'get_ea_compliance' : IDL.Func(
        [EAComplianceId],
        [IDL.Opt(EACompliance)],
        ['query'],
      ),
    'get_ea_data_object' : IDL.Func(
        [EADataObjectId],
        [IDL.Opt(EADataObject)],
        ['query'],
      ),
    'get_ea_diagram' : IDL.Func([IDL.Text], [IDL.Opt(IDL.Text)], ['query']),
    'get_ea_hr_role' : IDL.Func([EAHRRoleId], [IDL.Opt(EAHRRole)], ['query']),
    'get_ea_integration' : IDL.Func(
        [EAIntegrationId],
        [IDL.Opt(EAIntegration)],
        ['query'],
      ),
    'get_ea_organization' : IDL.Func(
        [EAOrganizationId],
        [IDL.Opt(EAOrganization)],
        ['query'],
      ),
    'get_ea_process' : IDL.Func(
        [EAProcessId],
        [IDL.Opt(EAProcess)],
        ['query'],
      ),
    'get_ea_process_connector' : IDL.Func(
        [EAProcessConnectorId],
        [IDL.Opt(EAProcessConnector)],
        ['query'],
      ),
    'get_ea_relationships_for' : IDL.Func(
        [IDL.Text, IDL.Text],
        [IDL.Vec(EARelationship)],
        ['query'],
      ),
    'get_ea_statistics' : IDL.Func([], [EAStatistics], ['query']),
    'get_ea_technical_service' : IDL.Func(
        [EATechnicalServiceId],
        [IDL.Opt(EATechnicalService)],
        ['query'],
      ),
    'get_interview_session' : IDL.Func(
        [InterviewSessionId],
        [IDL.Opt(InterviewSession)],
        ['query'],
      ),
    'get_inventory_field' : IDL.Func(
        [IDL.Text],
        [IDL.Opt(FlexeraInventoryField)],
        ['query'],
      ),
    'get_platform' : IDL.Func([PlatformId], [IDL.Opt(Platform)], ['query']),
    'get_process_flow' : IDL.Func(
        [ProcessFlowId],
        [IDL.Opt(ProcessFlow)],
        ['query'],
      ),
    'get_process_flow_statistics' : IDL.Func(
        [],
        [ProcessFlowStatistics],
        ['query'],
      ),
    'get_process_flows_by_capability' : IDL.Func(
        [IDL.Text, IDL.Text],
        [IDL.Vec(ProcessFlow)],
        ['query'],
      ),
    'get_process_steps' : IDL.Func(
        [ProcessFlowId],
        [IDL.Vec(ProcessStep)],
        ['query'],
      ),
    'get_questionnaire_response' : IDL.Func(
        [QuestionnaireResponseId],
        [IDL.Opt(QuestionnaireResponse)],
        ['query'],
      ),
    'get_questionnaire_responses_for_service' : IDL.Func(
        [BusinessServiceId],
        [IDL.Vec(QuestionnaireResponse)],
        ['query'],
      ),
    'get_risk' : IDL.Func([RiskId], [IDL.Opt(Risk)], ['query']),
    'get_risk_statistics' : IDL.Func([], [RiskStatistics], ['query']),
    'get_risks_for_control' : IDL.Func([ControlId], [IDL.Vec(Risk)], ['query']),
    'get_service_context' : IDL.Func([IDL.Text], [IDL.Text], ['query']),
    'get_service_document' : IDL.Func(
        [ServiceDocumentId],
        [IDL.Opt(ServiceDocument)],
        ['query'],
      ),
    'get_service_map' : IDL.Func([IDL.Text], [IDL.Opt(ServiceMap)], ['query']),
    'get_service_map_count' : IDL.Func([], [IDL.Nat32], ['query']),
    'get_service_relationships' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text, IDL.Text, IDL.Text, IDL.Text))],
        ['query'],
      ),
    'get_sessions_for_service' : IDL.Func(
        [BusinessServiceId],
        [IDL.Vec(InterviewSession)],
        ['query'],
      ),
    'get_supported_front_offices' : IDL.Func(
        [BusinessUnitId],
        [IDL.Vec(BusinessUnit)],
        ['query'],
      ),
    'get_timezone_config' : IDL.Func([], [TimezoneConfig], ['query']),
    'initialize_flexera_inventory_fields' : IDL.Func(
        [],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'link_business_service_to_map' : IDL.Func(
        [BusinessServiceId, IDL.Text, IDL.Text],
        [IDL.Variant({ 'Ok' : BusinessService, 'Err' : IDL.Text })],
        [],
      ),
    'link_risk_to_control' : IDL.Func(
        [RiskId, ControlId],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'list_business_capabilities' : IDL.Func(
        [],
        [IDL.Vec(BusinessCapability)],
        ['query'],
      ),
    'list_business_units' : IDL.Func([], [IDL.Vec(BusinessUnit)], ['query']),
    'list_business_units_by_type' : IDL.Func(
        [OfficeType],
        [IDL.Vec(BusinessUnit)],
        ['query'],
      ),
    'list_controls' : IDL.Func([], [IDL.Vec(Control)], ['query']),
    'list_controls_by_effectiveness' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(Control)],
        ['query'],
      ),
    'list_controls_by_type' : IDL.Func(
        [IDL.Text],
        [IDL.Vec(Control)],
        ['query'],
      ),
    'list_ea_applications' : IDL.Func([], [IDL.Vec(EAApplication)], ['query']),
    'list_ea_business_services' : IDL.Func(
        [],
        [IDL.Vec(EABusinessService)],
        ['query'],
      ),
    'list_ea_capabilities' : IDL.Func([], [IDL.Vec(EACapability)], ['query']),
    'list_ea_compliance' : IDL.Func([], [IDL.Vec(EACompliance)], ['query']),
    'list_ea_data_objects' : IDL.Func([], [IDL.Vec(EADataObject)], ['query']),
    'list_ea_hr_roles' : IDL.Func([], [IDL.Vec(EAHRRole)], ['query']),
    'list_ea_integrations' : IDL.Func([], [IDL.Vec(EAIntegration)], ['query']),
    'list_ea_organizations' : IDL.Func(
        [],
        [IDL.Vec(EAOrganization)],
        ['query'],
      ),
    'list_ea_process_connectors' : IDL.Func([], [IDL.Vec(EAProcessConnector)], ['query']),
    'list_ea_processes' : IDL.Func([], [IDL.Vec(EAProcess)], ['query']),
    'list_ea_relationships' : IDL.Func(
        [],
        [IDL.Vec(EARelationship)],
        ['query'],
      ),
    'list_ea_technical_services' : IDL.Func(
        [],
        [IDL.Vec(EATechnicalService)],
        ['query'],
      ),
    'list_platforms' : IDL.Func([], [IDL.Vec(Platform)], ['query']),
    'list_process_flows' : IDL.Func([], [IDL.Vec(ProcessFlow)], ['query']),
    'list_risks' : IDL.Func([], [IDL.Vec(Risk)], ['query']),
    'list_risks_by_category' : IDL.Func([IDL.Text], [IDL.Vec(Risk)], ['query']),
    'list_risks_by_severity' : IDL.Func([IDL.Text], [IDL.Vec(Risk)], ['query']),
    'list_risks_by_status' : IDL.Func([IDL.Text], [IDL.Vec(Risk)], ['query']),
    'list_service_map_names' : IDL.Func([], [IDL.Vec(IDL.Text)], ['query']),
    'pause_interview_session' : IDL.Func(
        [InterviewSessionId],
        [IDL.Variant({ 'Ok' : InterviewSession, 'Err' : IDL.Text })],
        [],
      ),
    'query_configs' : IDL.Func(
        [Embedding, IDL.Nat32],
        [ConfigQueryResult],
        ['query'],
      ),
    'search_activity_logs' : IDL.Func(
        [IDL.Text, IDL.Opt(IDL.Text), IDL.Nat64],
        [IDL.Vec(DeviceActivityLog)],
        ['query'],
      ),
    'search_configs_by_keyword' : IDL.Func(
        [IDL.Text],
        [
          IDL.Vec(
            IDL.Tuple(
              ConfigId,
              IDL.Text,
              IDL.Text,
              IDL.Text,
              IDL.Text,
              IDL.Text,
              IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
            )
          ),
        ],
        ['query'],
      ),
    'search_controls' : IDL.Func([IDL.Text], [IDL.Vec(Control)], ['query']),
    'search_risks' : IDL.Func([IDL.Text], [IDL.Vec(Risk)], ['query']),
    'seed_activity_log_data' : IDL.Func(
        [IDL.Text],
        [IDL.Variant({ 'Ok' : IDL.Vec(DeviceActivityLog), 'Err' : IDL.Text })],
        [],
      ),
    'set_timezone_config' : IDL.Func(
        [IDL.Int32, IDL.Text, IDL.Text],
        [IDL.Variant({ 'Ok' : IDL.Null, 'Err' : IDL.Text })],
        [],
      ),
    'similarity_search' : IDL.Func(
        [IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)), IDL.Nat32],
        [QueryResult],
        ['query'],
      ),
    'start_interview_session' : IDL.Func(
        [InterviewSessionId],
        [IDL.Variant({ 'Ok' : InterviewSession, 'Err' : IDL.Text })],
        [],
      ),
    'store_back_office_support' : IDL.Func(
        [BackOfficeSupportRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_business_capability' : IDL.Func(
        [BusinessCapabilityStorageRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_business_unit' : IDL.Func(
        [BusinessUnitStorageRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_capability_assignment' : IDL.Func(
        [CapabilityAssignmentRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_config' : IDL.Func(
        [
          ConfigId,
          IDL.Text,
          IDL.Text,
          IDL.Text,
          IDL.Text,
          Embedding,
          IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
        ],
        [IDL.Variant({ 'Ok' : IDL.Null, 'Err' : IDL.Text })],
        [],
      ),
    'store_control' : IDL.Func(
        [ControlRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_discovered_device' : IDL.Func(
        [StorageRequest],
        [IDL.Variant({ 'Ok' : StorageResponse, 'Err' : StorageError })],
        [],
      ),
    'store_ea_application' : IDL.Func(
        [EAApplicationRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_ea_business_service' : IDL.Func(
        [EABusinessServiceRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_ea_capability' : IDL.Func(
        [EACapabilityRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_ea_compliance' : IDL.Func(
        [EAComplianceRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_ea_data_object' : IDL.Func(
        [EADataObjectRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_ea_diagram' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Nat32],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_ea_hr_role' : IDL.Func(
        [EAHRRoleRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_ea_integration' : IDL.Func(
        [EAIntegrationRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_ea_organization' : IDL.Func(
        [EAOrganizationRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_ea_process' : IDL.Func(
        [EAProcessRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_ea_process_connector' : IDL.Func(
        [EAProcessConnectorRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_ea_relationship' : IDL.Func(
        [EARelationshipRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_ea_technical_service' : IDL.Func(
        [EATechnicalServiceRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_platform' : IDL.Func(
        [PlatformStorageRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_process_flow' : IDL.Func(
        [ProcessFlowStorageRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_process_step' : IDL.Func(
        [ProcessStepStorageRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_risk' : IDL.Func(
        [RiskRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'store_service_map' : IDL.Func(
        [ServiceMapStorageRequest],
        [ServiceMapStorageResponse],
        [],
      ),
    'unlink_risk_from_control' : IDL.Func(
        [RiskId, ControlId],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'update_business_service' : IDL.Func(
        [
          BusinessServiceId,
          IDL.Opt(IDL.Text),
          IDL.Opt(IDL.Text),
          IDL.Opt(ServiceCriticality),
          IDL.Opt(IDL.Vec(EntryPoint)),
          IDL.Opt(IDL.Vec(ServiceContact)),
          IDL.Text,
        ],
        [IDL.Variant({ 'Ok' : BusinessService, 'Err' : IDL.Text })],
        [],
      ),
    'update_business_service_status' : IDL.Func(
        [BusinessServiceId, ServiceStatus, IDL.Text],
        [IDL.Variant({ 'Ok' : BusinessService, 'Err' : IDL.Text })],
        [],
      ),
    'update_control' : IDL.Func(
        [ControlRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'update_device_inventory_field' : IDL.Func(
        [IDL.Text, IDL.Text, IDL.Text],
        [IDL.Variant({ 'Ok' : IDL.Null, 'Err' : IDL.Text })],
        [],
      ),
    'update_document_extracted_text' : IDL.Func(
        [ServiceDocumentId, IDL.Text],
        [IDL.Variant({ 'Ok' : ServiceDocument, 'Err' : IDL.Text })],
        [],
      ),
    'update_risk' : IDL.Func(
        [RiskRequest],
        [IDL.Variant({ 'Ok' : IDL.Text, 'Err' : IDL.Text })],
        [],
      ),
    'upload_service_document' : IDL.Func(
        [
          BusinessServiceId,
          DocumentType,
          IDL.Text,
          IDL.Text,
          IDL.Opt(IDL.Vec(IDL.Nat8)),
          IDL.Text,
        ],
        [IDL.Variant({ 'Ok' : ServiceDocument, 'Err' : IDL.Text })],
        [],
      ),
  });
};
export const init = ({ IDL }) => { return []; };
